/* ═══════════════════════════════════════════════════════════
   KOPPĀ — QR LANDING PAGE
   Progressive enhancement only. Every word of this page renders
   and every link works with this file blocked; the script adds
   the reveal motion, the sticky buy bar and the copy button.

   Deliberately dependency-free and deferred — QR traffic lands
   on cellular and the page must paint before this runs.
   ═══════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  var root = document.querySelector('.kqr');
  if (!root) return;

  var reduceMotion = window.matchMedia(
    '(prefers-reduced-motion: reduce)'
  ).matches;

  /* ── Scroll reveal ─────────────────────────────────────
     The hidden state lives behind .kqr--reveal-on, which is
     only added here. If this script never runs the content is
     simply visible — it is never trapped at opacity 0. */
  var reveals = root.querySelectorAll('.kqr__reveal');

  if (reveals.length && 'IntersectionObserver' in window && !reduceMotion) {
    root.classList.add('kqr--reveal-on');

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var el = entry.target;
          // Stagger siblings so a row settles in sequence.
          var delay = parseInt(el.getAttribute('data-kqr-delay') || '0', 10);
          setTimeout(function () {
            el.classList.add('is-in');
          }, delay);
          observer.unobserve(el);
        });
      },
      // Fire slightly before the element reaches the fold so the
      // motion reads as "already settling", not "popping in".
      { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
    );

    Array.prototype.forEach.call(reveals, function (el) {
      observer.observe(el);
    });
  }

  /* ── Sticky buy bar ───────────────────────────────────── */
  var sticky = root.querySelector('[data-kqr-sticky]');

  if (sticky) {
    var frame = 0;

    var onScroll = function () {
      if (frame) return;
      frame = window.requestAnimationFrame(function () {
        frame = 0;
        var past = window.scrollY > window.innerHeight * 0.85;
        sticky.classList.toggle('is-in', past);
        // Keep the CTA out of the tab order while it is off-screen.
        var link = sticky.querySelector('a');
        if (link) link.setAttribute('tabindex', past ? '0' : '-1');
        sticky.setAttribute('aria-hidden', past ? 'false' : 'true');
      });
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ── Copy the discount code ───────────────────────────── */
  var copyBtn = root.querySelector('[data-kqr-copy]');

  if (copyBtn && navigator.clipboard) {
    copyBtn.addEventListener('click', function () {
      navigator.clipboard
        .writeText(copyBtn.getAttribute('data-kqr-copy'))
        .then(function () {
          var original = copyBtn.textContent;
          copyBtn.textContent = 'Copied';
          setTimeout(function () {
            copyBtn.textContent = original;
          }, 2200);
        })
        .catch(function () {
          /* Clipboard blocked (insecure context or denied
             permission). The code is on screen regardless, so
             there is nothing to recover. */
        });
    });
  } else if (copyBtn) {
    copyBtn.hidden = true;
  }
})();
